export default __webpack_public_path__ + "static/media/background.10194b55.svg";